import React from "react";
import { useSelector } from "react-redux";
import TableContainer from "../TableContainer";
import PlotContainer from "../PlotContainer";
import { useGetConsiderationContributorsQuery, useGetShortMediumTermImpactQuery } from "../../redux/api/compassProject";
import '../containerStyles.css';

export default function ConsiderationContribution() {


    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedStartDate = useSelector((state) => state.genericReporting.selectedDropdownValues['start_date']);
    const selectedEndDate = useSelector((state) => state.genericReporting.selectedDropdownValues['end_date']);
    const selectedDateGranularity = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedDrivers = useSelector((state) => state.compass.drivers);

    return (
        <div>
            <div className="full-width-container">
                <PlotContainer useApi={useGetShortMediumTermImpactQuery} useApiArgs={{
                    client_name: selectedClient,
                    start_date: selectedStartDate,
                    end_date: selectedEndDate,
                    granularity: selectedDateGranularity,
                    drivers: selectedDrivers
                }} />
            </div>
            <div className="full-width-container">
                <PlotContainer useApi={useGetConsiderationContributorsQuery} useApiArgs={{
                    client_name: selectedClient,
                    start_date: selectedStartDate,
                    end_date: selectedEndDate,
                    granularity: selectedDateGranularity,
                    drivers: selectedDrivers
                }} />
            </div>
        </div>
    )
}